import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=e72f16fc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=e72f16fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72f16fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e72f16fc')) {
      api.createRecord('e72f16fc', component.options)
    } else {
      api.reload('e72f16fc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=e72f16fc&scoped=true&", function () {
      api.rerender('e72f16fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hWSQS9C6p6bF/JS/comp/PopupBox.vue"
export default component.exports